// import $ from 'dom7';
import Utils from '../../../../node_modules/framework7/utils/utils';


export default function F7ToolbarRedefine() {

	// app.f7.toolbar.init = function (tabbarEl) {
	// 	const app = this;
	// 	app.toolbar.setHighlight(tabbarEl);
	// };

	app.f7.toolbar.setHighlight = function (tabbarEl) {
		console.log('F7ToolbarRedefine');
		// const app = this;
		// if (app.theme !== 'md')
		// 	{
		// 	return;
		// 	}

		const $tabbarEl = $$(tabbarEl);

		if ($tabbarEl.length === 0 || !($tabbarEl.hasClass('tabbar') || $tabbarEl.hasClass('tabbar-labels')))
			{
			return;
			}

		let $highlightEl = $tabbarEl.find('.tab-link-highlight');
		const tabLinksCount = $(tabbarEl).find('.tab-link:visible').length;
		if (tabLinksCount === 0)
			{
			$highlightEl.remove();
			return;
			}

		if ($highlightEl.length === 0)
			{
			$tabbarEl.children('.toolbar-inner').append('<span class="tab-link-highlight"></span>');
			$highlightEl = $tabbarEl.find('.tab-link-highlight');
			}
		else if ($highlightEl.next().length)
			{
			$tabbarEl.children('.toolbar-inner').append($highlightEl);
			}

		let $activeLink = $tabbarEl.find('.tab-link-active');
		if ($activeLink.length === 0)
			{
			app.f7.tab.show( $($(tabbarEl).find('.tab-link:visible').attr('href')), $(tabbarEl).find('.tab-link:visible')[0], false)
			// this.show($(tabbarEl).find('.tab-link:visible')[0]);
			// $activeLink = $$($(tabbarEl).find('.tab-link:visible')[0]);
			}
		let highlightWidth;
		let highlightTranslate;

		if ($tabbarEl.hasClass('tabbar-scrollable') && $activeLink && $activeLink[0])
			{
			highlightWidth = `${$activeLink[0].offsetWidth}px`;
			highlightTranslate = `${$activeLink[0].offsetLeft}px`;
			}
		else
			{
			let activeIndex = $(tabbarEl).find('.tab-link:visible').index($(tabbarEl).find('.tab-link-active'));
			// if(activeIndex===-1)
			// 	{
			// 	activeIndex = $(tabbarEl).find('.tab-link:visible').index($(tabbarEl).find('.tab-link:visible'));
			// 	}
			highlightWidth = `${100 / tabLinksCount}%`;
			highlightTranslate = `${(this.rtl ? -activeIndex : activeIndex) * 100}%`;
			}

		Utils.nextFrame(() => {
			$highlightEl
				.css('width', highlightWidth)
				.transform(`translate3d(${highlightTranslate},0,0)`);
		});
	};
}
